import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Keyframes } from '@ant-design/cssinjs';
import { initFadeMotion } from '../../style/motion';
var uploadAnimateInlineIn = new Keyframes('uploadAnimateInlineIn', {
  from: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
});
var uploadAnimateInlineOut = new Keyframes('uploadAnimateInlineOut', {
  to: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}); // =========================== Motion ===========================

var genMotionStyle = function genMotionStyle(token) {
  var _$concat;

  var componentCls = token.componentCls;
  var inlineCls = "".concat(componentCls, "-animate-inline");
  return [_defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat = {}, _defineProperty(_$concat, "".concat(inlineCls, "-appear, ").concat(inlineCls, "-enter, ").concat(inlineCls, "-leave"), {
    animationDuration: token.motionDurationSlow,
    animationTimingFunction: token.motionEaseInOutCirc,
    animationFillMode: 'forwards'
  }), _defineProperty(_$concat, "".concat(inlineCls, "-appear, ").concat(inlineCls, "-enter"), {
    animationName: uploadAnimateInlineIn
  }), _defineProperty(_$concat, "".concat(inlineCls, "-leave"), {
    animationName: uploadAnimateInlineOut
  }), _$concat)), _defineProperty({}, "".concat(componentCls, "-wrapper"), initFadeMotion(token)), uploadAnimateInlineIn, uploadAnimateInlineOut];
};

export default genMotionStyle;